<template>
  <div>
    <h2 class="text-2xl font-bold mt-10 mb-4">{{ $t("education") }}</h2>
    <div class="space-y-4 text-sm">
      <div v-for="(edu, index) in education" :key="index">
        <h3 class="font-bold">{{ edu.school }}</h3>
        <p>{{ edu.degree }}</p>
        <p v-if="edu.details">{{ edu.details }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

interface EducationItem {
  school: string;
  degree: string;
  details?: string;
}

@Options({})
export default class Education extends Vue {
  get education(): EducationItem[] {
    return [
      {
        school: this.$t("educations.schools.vut"),
        degree: this.$t("educations.degrees.masters"),
      },
      {
        school: this.$t("educations.schools.mikkeli"),
        degree: this.$t("educations.degrees.it"),
        details: this.$t("educations.degrees.business"),
      },
    ];
  }
}
</script>
